module.exports = __webpack_public_path__ + "img/signboard.ac7302e5.png";